module.exports = __webpack_public_path__ + "static/media/Banner.391d32bd.jpg";